import React from "react";
import SectionHeading from "../SectionHeading";
import ProjectCard from "./ProjectCard";

export default function ProjectList({
  theme,
  text,
  loading,
  filteredProjects,
  projects,
  selectedProjectId,
  onSelect,
  onEdit,
  onDelete,
  t,
}) {
  return (
    <>
      <SectionHeading title={text.projectList} subtitle={`${filteredProjects.length} ${text.filteredProjects}`} />

      <div className="mt-4 space-y-4">
        {loading ? (
          <div className={`rounded-[26px] border border-dashed px-6 py-12 text-center text-sm ${theme === "dark" ? "border-slate-800 text-slate-400" : "border-slate-200 text-slate-500"}`}>
            {t.loading || "Loading..."}
          </div>
        ) : filteredProjects.length ? (
          filteredProjects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              selected={selectedProjectId === project.id}
              theme={theme}
              text={text}
              onSelect={() => onSelect(project.id)}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))
        ) : (
          <div className={`rounded-[26px] border border-dashed px-6 py-12 text-center ${theme === "dark" ? "border-slate-800 text-slate-400" : "border-slate-200 text-slate-500"}`}>
            <div className="text-base font-semibold">{projects.length ? text.noResults : text.noProjects}</div>
            <div className="mt-2 text-sm">{projects.length ? text.noResultsText : text.noProjectsText}</div>
          </div>
        )}
      </div>
    </>
  );
}
